export default {
    methods: {
        sendPasswordReset(user) {
            this.$confirm(
                `Confirm send password reset link to ${user.email}?`,
                "Confirmation",
                {
                    confirmButtonText: "Send",
                    cancelButtonText: "Cancel",
                    confirmButtonClass: "el-button--danger",
                },
            )
                .then(() => {
                    this.addBusyItem(user, "send password reset");
                    axios
                        .post(`/web-api/user/${user.id}/send-password-reset`)
                        .then(() => {
                            this.$notify.success({
                                message: `Password reset link has been sent to ${user.email}.`,
                            });
                        })
                        .finally(() => {
                            this.removeBusyItem(user, "send password reset");
                        });
                })
                .catch((e) => {
                    console.log("sendPasswordReset", e);
                });
        },
    },
};
